import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePromise } from '../../../../../hooks/usePromise/usePromise';
import { useEthConverter } from '../../../../../hooks/useConverter';
import configJson from '../../../../../config/config.json';
import { getValueByMultiProps } from '../../../../../utils/mapper';
import { getTokenPriceByAddress } from '../../../../../services/scanService';

export const handleVerySmallNumbers = (number) => {
  const stringValue = number?.toString() || '';
  const hasNegativeExpo = stringValue.includes('e-');
  if (!hasNegativeExpo) return number;
  const negativeSignPosition = stringValue.indexOf('-');
  const numberOfDecimals = stringValue.charAt(negativeSignPosition + 1);
  return number.toFixed(numberOfDecimals);
};

export const _toFixed = (num = '0.0') => {
  try {
    let _num = num.toString();
    const decimalIndex = _num.indexOf('.');
    const rightToDecimal = _num.substring(decimalIndex + 1, num.length - 1);
    const firstValidNum = rightToDecimal.split('').findIndex((num) => +num > 0);
    _num = +_num;
    const validatedNum = _num.toFixed(firstValidNum + 1);
    return validatedNum;
  } catch (error) {
    return num;
  }
};

export const displaySmallFLoats = (num = 0.0, maxDigits = 100) => +(+num).toFixed(maxDigits);

export default function TokenPrice({ token, children }) {
  const [, , , , mergedConverter] = useEthConverter();
  const { baseCoin } = configJson;
  const coinConverter = mergedConverter?.[baseCoin.toLowerCase()] || [];
  const [, usdToCoin, bnbInUsd] = coinConverter;
  const tokenAddress = getValueByMultiProps(token, ['address', 'token_address']);

  const [
    getUsdPrice,
    {
      data: { price },
    },
  ] = usePromise(() => getTokenPriceByAddress(tokenAddress), { defaultRes: { data: { price: 0.0 } } });

  const onlyTwoDec = _toFixed(price);
  const ethEqValue = usdToCoin(onlyTwoDec);

  useEffect(() => {
    if (tokenAddress) getUsdPrice();
  }, [tokenAddress]);

  return <>{children({ usdEqValue: onlyTwoDec, ethEqValue, bnbInUsd })}</>;
}
TokenPrice.propTypes = {
  token: PropTypes.object,
  children: PropTypes.func,
};

TokenPrice.defaultProps = {
  token: null,
  children: null,
};
